module.exports = __webpack_public_path__ + "static/media/chuveiro.bd2c8766.svg";